import React from 'react'
import { Box, Button } from '@mui/joy'
import CallEndIcon from '@mui/icons-material/CallEnd'
import MicOffIcon from '@mui/icons-material/MicOff'
import MicIcon from '@mui/icons-material/Mic'
import { CallStatus } from '@numeo/types'

interface CallControlsProps {
    callStatus: CallStatus
    isMuted: boolean
    endingCall: boolean
    onToggleMute: () => void
    onHangup: () => void
}

export const CallControls: React.FC<CallControlsProps> = ({ callStatus, isMuted, endingCall, onToggleMute, onHangup }) => {
    return (
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', gap: 1 }}>
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-between' }}>
                {/* <Tooltip title={onToggleHold ? (isOnHold ? 'Resume' : 'Hold') : 'Hold is not available for now'}>
                    <Button
                        disabled={!onToggleHold}
                        color={isOnHold ? 'warning' : 'primary'}
                        variant="soft"
                        fullWidth
                        size="sm"
                        onClick={onToggleHold}
                        startDecorator={isOnHold ? <PlayArrowIcon /> : <PauseIcon />}
                    >
                        {isOnHold ? 'Resume' : 'Hold'}
                    </Button>
                </Tooltip> */}
                <Button
                    color={isMuted ? 'warning' : 'primary'}
                    variant="soft"
                    fullWidth
                    size="sm"
                    onClick={onToggleMute}
                    startDecorator={isMuted ? <MicOffIcon /> : <MicIcon />}
                >
                    {isMuted ? 'Unmute' : 'Mute'}
                </Button>
            </Box>

            <Button
                disabled={[CallStatus.ENDED, CallStatus.BUSY].includes(callStatus)}
                color="danger"
                variant="soft"
                size="sm"
                onClick={onHangup}
                startDecorator={<CallEndIcon />}
                loading={endingCall}
            >
                End Call
            </Button>
        </Box>
    )
}
